var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 37,
    viewBox: "0 0 28 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5941 35.7969C2.32852 21.0312 0.500391 19.4844 0.500391 14C0.500391 6.54688 6.47695 0.5 14.0004 0.5C21.4535 0.5 27.5004 6.54688 27.5004 14C27.5004 19.4844 25.602 21.0312 15.3363 35.7969C14.7035 36.7812 13.227 36.7812 12.5941 35.7969ZM14.0004 19.625C17.0941 19.625 19.6254 17.1641 19.6254 14C19.6254 10.9062 17.0941 8.375 14.0004 8.375C10.8363 8.375 8.37539 10.9062 8.37539 14C8.37539 17.1641 10.8363 19.625 14.0004 19.625Z",
    fill: "#189BF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueLocation);
export default __webpack_public_path__ + "static/media/blue-location.03b2fadb6bf6e5c5ce5b3c1bf9375f72.svg";
export { ForwardRef as ReactComponent };